import { Component, EventEmitter, Input, OnChanges, Output, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../shared/services/commen/commen.services';
import { environment } from '../../../../environments/environment';
import { Http } from '@angular/http';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-new-registration-upload',
  templateUrl: './new-registration-upload.component.html',
  styleUrls: ['./new-registration-upload.component.scss']
})
export class NewRegistrationUploadComponent implements OnInit {

  @Input() data: any;
  @Input() networkId: any;
  @Input() isRegistrationSave: any;
  @Output() modifiedValueOutput = new EventEmitter<any>()
  @Output() onFileSelect = new EventEmitter<any>();
  @Output() onFileDelete = new EventEmitter<any>();

  Label: any;
  Number: any;
  IsForLifeTime: any;
  FileName: any;
  Validity: any;

  registrationObj: any = {};

  listOfFile: any[];
  registerarray: any[] = [];

  isdatedisable: boolean;

  constructor(
    private translate: TranslateService,
    private _appService: appService,
    private commonService: CommonService,
    private anghttp: Http,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    // this.initializeform();
    this.GetRegister();
  }

  ngOnChanges(changes: SimpleChanges): void {

  }
  listOfField = []

  // initializeform() {
  //   this.FileName={
  //       Label:"File Name",
  //       dataField:"FileName",
  //       formControlName: 'FileName',
  //   };
  //   this.Number={
  //       Label:"Number",
  //       dataField:"Number",
  //       formControlName: 'Number',
  //   };
  //   this.IsForLifeTime= {
  //         lable: "Is Default",
  //         dataField: 'IsDefaultNew',
  //   };
  //   this.Validity={
  //       lable: "Date",
  //         placeholder: "Select date",
  //         dataField: 'Validity',
  //         formControlName: 'Validity',
  //   };
  // }

  getChangedValue(value, dataFeild, item) {

    item[dataFeild] = value;
    if (dataFeild == "IsForLifeTime") {
      this.isdatedisable = value;
    }
    const filteredData = this.registerarray.map(item => {
      const { FileNameObj, NumberObj, IsForLifeTimeObj, ValidityObj, ...filteredItem } = item;
      return filteredItem;
    });
    console.log("getchanged", value, dataFeild);
    console.log("getchanged", filteredData);
  }


  onFileDeleteFn(selectedFile) {
    this.onFileDelete.emit(selectedFile);
  }

  getFilePreview(item) {
    if (item.documentpath && item.documentpath !== "." && item.filename) {

      const fullFileName = item.filepath || "";
      const displayFileName = fullFileName.includes("_")
        ? fullFileName.split("_").pop()
        : fullFileName;

      return [{ name: item.filename, url: item.filepath }];
    } else {

      return [];
    }
  }


  GetRegister() {

    this._appService.GetById("Network", "GetRegisteredDocss", this.networkId).subscribe(
      (res) => {
        this.registerarray = res.map((item) => {

          const fullFileName = item.FileName || "";
          const displayFileName = fullFileName.includes("_")
            ? fullFileName.split("_").pop()
            : fullFileName;


          const filepath = environment.apiUrl + item.DocumentPath;
          console.log("filepath", filepath);

          return {
            ...item,
            FileNameObj: {
              Label: "File Name",
              dataField: "FileName",
              formControlName: "FileName",
              documentpath: item.DocumentPath,
              filepath: filepath,
              filename: displayFileName,

            },
            NumberObj: {
              Label: "Number",
              dataField: "Number",
              formControlName: "Number",
              placeholder: "Enter number",
            },
            IsForLifeTimeObj: {
              lable: "Is Default",
              dataField: "IsForLifeTime",
            },
            ValidityObj: {
              // lable: "Date",
              placeholder: "Select date",
              dataField: "Validity",
              formControlName: "Validity",
              isReadOnly: this.isdatedisable,
            },
          };
        });

        console.log(this.registerarray);
      },
      (error) => {
        console.log("Error while Getting Register", error);
      }
    );
  }

  onFileSelectFn(event: any, data: any) {

    const selectedFile = event.target.files[0];
    const { formData, options } = this.commonService.setHeaderAndOptionsForFileUpload(selectedFile);
    const apiUrl =
      environment.apiUrl +
      "/api/Document/UploadAttachment?ReferenceId=" +
      this.networkId +
      "&TransectionType=" +
      data.Label +
      "&ParentId=" +
      null;
    const req1 = this.anghttp.post(apiUrl, formData, options).subscribe(
      (response) => {
        var uploadSuccess = this.translate.instant("Attachment.AttachmentUploadSuccess")
        this.toastr.success(
          uploadSuccess,
          "success"
        );
      },
      (err) => {
        var uploadError = this.translate.instant("Attachment.UploadError")
        this.toastr.error(uploadError, "error");
      }
    );
  }


  saveRegistrationData() {

    const filteredData = this.registerarray.map(item => {
      item.IsNetworkCompany = true;
      const { FileNameObj, NumberObj, IsForLifeTimeObj, ValidityObj, ...filteredItem } = item;
      return filteredItem;
    });

    this._appService
      .Post("Company", "SaveRegistration", filteredData)
      .subscribe(
        (response) => {
          this.toastr.success(
            "Registration data saved Successfully !",
            "Success"
          );
          //added by vithujan 26-12-2022
          this.GetRegister();
        },
        (err) => {
          this.toastr.error(
            "Error occurred while saving Registration Data !",
            "error"
          );
        }
      );
  }
}
